"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelOrderLineChanges = void 0;
const dayjs = require("dayjs");
const pluralize_1 = require("../pluralize");
const roomsDiffFromDescriptions_1 = require("./roomsDiffFromDescriptions");
const getHotelOrderLineChanges = (previous, current) => {
    const changed_items = [];
    const changes = {};
    // Check if date has changed
    if (previous.where_when_who.check_in_date !==
        current.where_when_who.check_in_date) {
        changed_items.push("Check-in date");
        changes.date = {
            has_changed: true,
            previous_value: dayjs(previous.where_when_who.check_in_date).format("ddd, Do MMM YYYY"),
        };
    }
    // has the number of guests changed?
    if (previous.where_when_who.number_of_guests !==
        current.where_when_who.number_of_guests) {
        changed_items.push("No. of guests");
        changes.people = {
            has_changed: true,
            previous_value: (0, pluralize_1.pluralize)(previous.where_when_who.number_of_guests, "Guest", "Guests"),
        };
    }
    // has the number of guests changed?
    if (previous.where_when_who.number_of_nights !==
        current.where_when_who.number_of_nights) {
        changed_items.push("No. of nights");
        changes.nights = {
            has_changed: true,
            previous_value: (0, pluralize_1.pluralize)(previous.where_when_who.number_of_nights, "Night", "Nights"),
        };
    }
    // Rooms (via your own description mechanism)
    const descDiff = (0, roomsDiffFromDescriptions_1.diffHotelLineDescriptions)(previous, current);
    if (descDiff.hasChanged) {
        changed_items.push("Rooms");
        changes.rooms = {
            has_changed: true,
            bullets: descDiff.bullets,
            summary: descDiff.summary,
            diff: descDiff, // keep for machine use if needed
        };
    }
    return {
        ...changes,
        changes: changed_items,
    };
};
exports.getHotelOrderLineChanges = getHotelOrderLineChanges;
